<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title> Logs for {{ pmsConnDetails.usr }} </v-card-title>
          <v-card-subtitle>{{ pmsConnDetails.pmsType }}</v-card-subtitle>

          <v-container>
            <v-row>
              <v-col>
                <v-datetime-picker
                  label="From"
                  v-model="start"
                  dateFormat="dd/MM/yyyy"
                  timeFormat="hh:mm aa"
                  :text-field-props="textFieldProps"
                  class="pa-10"
                >
                  <template v-slot:dateIcon>
                    Date
                  </template>
                  <template v-slot:timeIcon>
                    Time
                  </template>
                </v-datetime-picker>
              </v-col>

              <v-col>
                <v-datetime-picker
                  class="pa-10"
                  label="To"
                  v-model="end"
                  dateFormat="dd/MM/yyyy"
                  timeFormat="hh:mm aa"
                  :text-field-props="textFieldProps"
                >
                  <template v-slot:dateIcon>
                    Date
                  </template>
                  <template v-slot:timeIcon>
                    Time
                  </template>
                </v-datetime-picker>
              </v-col>

              <v-col>
                <v-btn
                  color="primary"
                  :loading="loading"
                  @click="getLogs(sub)"
                  right
                >
                  Search Dates
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="filter"
                  :disabled="!logs || !logs.length"
                  append-icon="mdi-magnify"
                  label="Filter Results"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="4">
                
                <template>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-btn
                          :disabled="!nextBackwardToken"
                          v-if="nextBackwardToken"
                          :loading="loading"
                          color="success"
                          small
                          @click="getLogs(sub, nextBackwardToken)"
                        >
                          Try Geting Earlier Results for Dates
                        </v-btn>
                      </span>
                    </template>
                    <span
                      >There may be earlier logs for these dates. Try getting earlier results in
                      your date range by clicking here.</span
                    >
                  </v-tooltip>
                </template>
                <template>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-btn
                          :disabled="!nextForwardToken"
                          v-if="nextForwardToken"
                          :loading="loading"
                          color="success"
                          small
                          @click="getLogs(sub, nextForwardToken)"
                        >
                          Try Getting Later Results for Dates
                        </v-btn>
                      </span>
                    </template>
                    <span
                      >There may be more recent logs for these dates. Try getting later results in
                      your date range by clicking here.</span
                    >
                  </v-tooltip>
                </template>
              </v-col>
            </v-row>
          </v-container>

          <v-data-table
            :headers="logsHeaders"
            :items="logs"
            :options="logsOptions"
            :search="filter"
            :loading="loading"
          >
            <template v-slot:item.timestamp="{ item }">
              <span v-if="item.timestamp > 0">{{
                new Date(item.timestamp).toLocaleString("en-AU")
              }}</span>
              <span v-else>n/a</span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  props: {
    pmsConnDetails: Object,
  },
  data: function () {
    return {
      sub: "",
      loading: false,
      start: new Date(),
      end: new Date(),
      nextForwardToken: "",
      nextBackwardToken: "",
      logs: [],
      filter: "",
      logsOptions: {
        sortBy: ["timestamp"],
        sortDesc: [true],
      },
      logsHeaders: [
        {
          text: "Date",
          value: "timestamp",
          sortable: true,
        },
        {
          text: "Type",
          value: "type",
          sortable: true,
          groupable: true,
        },
        { text: "Message", value: "message", sortable: false },
      ],
      textFieldProps: {
        appendIcon: 'mdi-calendar',
        dense: true,
        class: ''
      },
    };
  },
  created: async function () {
    this.sub = this.$route.params.sub;

    const start = new Date();
    start.setHours(0, 0, 0);
    this.start = start;

    const end = new Date();
    end.setHours(23, 59, 59, 999);
    this.end = end;

    this.getLogs(this.sub);
  },
  methods: {
    async getLogs(sub, nextToken) {
      this.loading = true;
      try {
        const getLogsResponse = await API.graphql(
          graphqlOperation(queries.getLogs, {
            sub,
            startTime: this.start.getTime(),
            endTime: this.end.getTime(),
            nextToken,
          })
        );
        console.log("getLogs response", getLogsResponse);
        if (
          !getLogsResponse?.data.getLogs ||
          getLogsResponse?.errors?.length > 0
        ) {
          await this.handleResponseError(
            "Error retrieving logs",
            getLogsResponse
          );
        }

        if (getLogsResponse?.data?.getLogs) {
          const logEvents = getLogsResponse.data.getLogs.events.map((l) => {
            let log = {
              timestamp: l.timestamp,
              message: l.message,
              type: "",
            };

            try {
              const logDetails = JSON.parse(l.message.replace("'", ""));
              log.message = logDetails.msg;
              log.type = logDetails.type;
            } catch (jsonErr) {
              console.log("can't parse json", l.message, jsonErr);
            }
            return log;
          });

          if (nextToken) {
            this.logs = this.logs.concat(logEvents);
          }
          else {
            this.logs = logEvents;
          }

          console.log("getLogsResponse.data.getLogs.nextBackwardToken", getLogsResponse.data.getLogs.nextBackwardToken);

          console.log("getLogsResponse.data.getLogs.nextForwardToken", getLogsResponse.data.getLogs.nextForwardToken);

          if (nextToken) {
            console.log("nextToken", nextToken);
          }

          const isGoingForward = nextToken && nextToken == this.nextForwardToken;

          if (nextToken && getLogsResponse.data.getLogs.nextBackwardToken == nextToken) {
            this.nextBackwardToken = "";
          } else if ( nextToken && isGoingForward) {
            // don't update backward token when going fowrard
          }
          else {
            this.nextBackwardToken = getLogsResponse.data.getLogs.nextBackwardToken;
          }

          if (nextToken && getLogsResponse.data.getLogs.nextForwardToken == nextToken) {
            this.nextForwardToken = "";
          } else if (nextToken && !isGoingForward) {
            // don't update forward token when going backward
          }
          else {
            this.nextForwardToken = getLogsResponse.data.getLogs.nextForwardToken;
          }


          console.log("getLogs set this.logs", this.logs);
        }
      } catch (err) {
        console.log("getLogs exception", err);

        await this.handleResponseError("Error retrieving logs", err);
      } finally {
        this.loading = false;
      }
    },
    async handleResponseError(operationDescription, response) {
      console.log("handleResponseError", response);
      const notifyResult = await this.$dialog.notify.error(
        operationDescription,
        {
          position: "top-right",
          timeout: 5000,
          actions: [{ text: "Info", "x-small": true, color: "secondary" }],
        }
      );

      if (notifyResult == "Info") {
        this.$dialog.error({
          text: JSON.stringify(response?.errors || response),
          title: operationDescription,
          icon: "mdi-error",
        });
      }
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
  },
};
</script>